export const Tools = {
  Base: {
    path: '/tools',
    name: 'tools'
  },
  DealCopyRequest: {
    path: '/tools/automotive/dealdocumentcopy/request/dealCopyRequest',
    name: 'dealCopyRequest'
  },
  DealCopyHistory: {
    path: '/tools/automotive/dealdocumentcopy/history/dealCopyHistory',
    name: 'dealCopyHistory'
  },
  ProcessLeaver: {
    path: '/tools/processleaver',
    name: 'processLeaver'
  },
  ProcessLeaverHistory: {
    path: '/tools/processLeaverHistory',
    name: 'processLeaverHistory'
  },
  LeaverHistoryLog: {
    path: '/tools/leaverhistorylog/:leaverId',
    name: 'leaverHistoryLog'
  },
  LockMaintenance: {
    path: '/tools/systemTools/lockMaintenance',
    name: 'lockMaintenance'
  },
  ClearCacheSettings: {
    path: '/tools/systemTools/clearCacheSettings',
    name: 'clearCacheSettings'
  },
  DocumentRetention: {
    path: '/tools/documentRetention',
    name: 'documentRetention'
  },
  GenerateExceptionalJob: {
    path: '/tools/generateExceptionalJob',
    name: 'generateExceptionalJob'
  },
  ExceptionalJobs: {
    path: '/tools/exceptionalJobs',
    name: 'exceptionalJobReport'
  }
};
